import deviceMicroPortalViewerComponent from './deviceMicroPortalViewer.component';

const deviceMicroPortalViewerModule = angular.module('app.components.clinicalData.deviceMicroPortalViewer', [])
	.component('clinicalDataDeviceMicroPortalViewer', deviceMicroPortalViewerComponent)
	.name;

export default deviceMicroPortalViewerModule;
